import { KeyboardEvent } from "react";
import { Box, Typography } from "@mui/material";
import { FONT_WEIGHTS } from "../theme/fontWeights";

interface IProps {
    id: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    label?: string;
    labelAlign?: "inherit" | "left" | "center" | "right" | "justify";
    labelColor?: "inherit" | "primary" | "secondary" | "error" | "info" | "success" | "warning";
    labelFontWeight?: keyof typeof FONT_WEIGHTS;
    ariaLabelledby?: string;
    dataTestId?: string;
    inputClassName?: string;
    className?: string;
    fullWidth?: boolean;
    onKeyDown?: (event: KeyboardEvent<HTMLLabelElement>) => void;
}

export const Switch = (props: IProps) => {
    const {
        id,
        checked,
        onChange,
        label,
        labelAlign,
        labelColor,
        labelFontWeight,
        ariaLabelledby,
        dataTestId,
        inputClassName,
        className,
        fullWidth = true,
        onKeyDown,
    } = props;

    const labelId = `label-${id}`;
    const resolvedAriaLabelledby = ariaLabelledby ?? (label ? labelId : undefined);

    return (
        <Box
            alignItems="center"
            className={className}
            display="flex"
            justifyContent="space-between"
            width={fullWidth ? "100%" : "auto"}
        >
            {label && (
                <Typography
                    align={labelAlign}
                    color={labelColor}
                    fontWeight={labelFontWeight ? FONT_WEIGHTS[labelFontWeight] : FONT_WEIGHTS.light}
                    id={labelId}
                    variant="normal"
                >
                    {label}
                </Typography>
            )}
            <div className="checkbox">
                <input
                    aria-labelledby={resolvedAriaLabelledby}
                    checked={checked}
                    className={inputClassName}
                    data-testid={dataTestId}
                    id={id}
                    type="checkbox"
                    onChange={(event) => onChange(event.target.checked)}
                />
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control,jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/no-noninteractive-tabindex */}
                <label htmlFor={id} tabIndex={0} onKeyDown={onKeyDown} />
            </div>
        </Box>
    );
};
